export const FONT_SIZE_STORAGE_KEY = 'xtram-font-size';
export const FONT_SIZE_VALUES = ['small', 'medium', 'large'];
export const DEFAULT_FONT_SIZE = 'medium';

export const FONT_SIZE_OPTIONS = [
  { value: 'small', labelKey: 'FontSizeSmall' },
  { value: 'medium', labelKey: 'FontSizeMedium' },
  { value: 'large', labelKey: 'FontSizeLarge' },
];

/** MUI typography.fontSize (px). Medium keeps the library default of 14. */
export const FONT_SIZE_TO_MUI = {
  small: 13,
  medium: 14,
  large: 16,
};

export const isValidFontSize = (value) => FONT_SIZE_VALUES.includes(value);

export const getStoredFontSize = () => {
  try {
    const stored = localStorage.getItem(FONT_SIZE_STORAGE_KEY);
    return isValidFontSize(stored) ? stored : DEFAULT_FONT_SIZE;
  } catch {
    return DEFAULT_FONT_SIZE;
  }
};

export const applyFontSize = (value) => {
  const next = isValidFontSize(value) ? value : DEFAULT_FONT_SIZE;
  if (typeof document !== 'undefined') {
    document.documentElement.dataset.fontSize = next;
  }
  return next;
};

export const persistFontSize = (value) => {
  const next = applyFontSize(value);
  try {
    localStorage.setItem(FONT_SIZE_STORAGE_KEY, next);
  } catch {
    /* ignore quota / private mode */
  }
  return next;
};

applyFontSize(getStoredFontSize());
